import { RequestSalePointsParams, SalePoint } from 'app/common/types/sale-points'
import { SalePointId } from 'app/common/types/id'
import type { Request } from '../../../index'

type UrlParams = {
  orgId: string
}

export const convertParams = (
  params: RequestSalePointsParams,
): [{ building_id?: number }, UrlParams] => {
  const { orgId, buildingId } = params
  return [buildingId ? { building_id: parseInt(buildingId, 10) } : {}, { orgId }]
}

export const convertResult = (
  categories: Record<string, {
    id: number;
    title: string;
    deleted: boolean;
    for_order: boolean
    vending_machines_counter: number
  }>,
): Array<SalePoint> => {
  return Object.values(categories).map(({
    id,
    title,
    deleted,
    for_order: forOrder,
    vending_machines_counter: vendingMachinesCounter
  }) => ({
    id: String(id) as SalePointId,
    title,
    deleted,
    forOrder,
    vendingMachinesCounter
  }))
}

export const GET_SALE_POINTS: Request<RequestSalePointsParams, Array<SalePoint>, UrlParams> = [
  'food/schools/{orgId}/sale_points',
  'get',
  ['data', 'sale_points'],
]
